// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__135tB","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3XY3U","obliqueLine":"membershipbadge_obliqueLine__2a4Sl"};